import React from "react";
import PropTypes from "prop-types";
import Cookie from "js-cookie";
import AuthFirstStep from "../../components/commons/AuthFirstStep";
class AdminFirstStepAuth extends React.Component {
  static defaultProps = {
    onSubmit: () => {},
    onChangeUsername: (username = "") => undefined,
    onChangePassword: (password = "") => undefined,
  };

  static propTypes = {
    username: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    onChangeUsername: PropTypes.func.isRequired,
    onChangePassword: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    validateAdminFirstStep: PropTypes.func.isRequired,
    onChangeRememberDevice: PropTypes.func.isRequired,
    classes: PropTypes.object,
    stepError: PropTypes.string,
    isSucessUserName: PropTypes.bool,
    isFetching: PropTypes.bool,
    rememberDevice: PropTypes.bool.isRequired,
  };

  state = {
    error: "",
  };

  handleOnSubmit = () => {
    const { username = "", password = "" } = this.props;

    if (!!username && !!password) {
      this.props.onSubmit();
    } else {
      this.setState({
        error: "please fill the form",
      });
    }
  };

  handleKeyPress = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      this.handleOnSubmit();
    }
  };

  setRememberDevice = () => {
    const { rememberDevice = false } = this.props;

    const doDelete = () => {
      Cookie.remove("REMEMBER_DEVICE");
      localStorage.removeItem("rememberDevice");
    };

    const doSet = () => {
      Cookie.set("REMEMBER_DEVICE", JSON.stringify(true));
      localStorage.setItem("rememberDevice", JSON.stringify(true));
    };

    if (!rememberDevice) doSet();
    else doDelete();
  };

  handleChangeRememberDevice = ({ target }) => {
    try {
      const { rememberDevice, onChangeRememberDevice } = this.props;

      onChangeRememberDevice(!rememberDevice);

      this.setRememberDevice();
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const {
      stepError,
      isFetching,
      classes,
      phrase,
      validateAdminFirstStep,
      isSucessUserName,
      rememberDevice,
      password,
      username,
      onChangePassword,
      onChangeUsername,
    } = this.props;

    const { error } = this.state;

    const hasError = stepError || error || !password || !username;

    return (
      <AuthFirstStep
        disableLoginButton={!isSucessUserName || isFetching || hasError}
        isPrimaryLoginButton={!isFetching && isSucessUserName && !hasError}
        password={password}
        email={username}
        isFetching={isFetching}
        rememberDevice={rememberDevice}
        title="Sign In"
        error={hasError}
        classes={classes}
        phrase={phrase}
        onChangeRememberDevice={this.handleChangeRememberDevice}
        onClickLoginButton={this.handleOnSubmit}
        onBlurEmail={() => username !== "" && validateAdminFirstStep(username)}
        onChangePassword={({ target }) => {
          const password = target.value;

          onChangePassword(password);
        }}
        onChangeEmail={({ target }) => {
          const username = target.value;

          onChangeUsername(username);
        }}
        onKeyPressEmail={this.handleKeyPress}
        onKeyPressPassword={this.handleKeyPress}
      />
    );
  }
}

export default AdminFirstStepAuth;
